import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';

interface IErrorServerProps {
    className?: string;
    onTryAgain?: () => void
}

export const ErrorServer: React.FunctionComponent<IErrorServerProps> = (props) => (
    <div className="tc-st tc-ccd-error">
        <div id="tc-st-page-load-center">
            <div className="tc-st-page-load-indicator-container">
                <div>
                    <div className="tc-st-page-load-indicator">
                        <SvgIcon name="icon-system-server-error" className="comments-icon-size" />
                    </div>
                    <span className="tc-st-page-load-failed-text">
                        Failed to load the requested resource
                    </span>
                    <div className="tc-st-try-again">
                        <Button onClick={props.onTryAgain}>Try again</Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
